

import * as React from "react";
export const SvgComponent = ({ title, handleCircle, ...props }) => {
    return (
        <div className="svgContainer">
            <h2>{title}</h2>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 883.37 1005.29"
                {...props}
            >
                <defs>
                    <style>
                        {
                            "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: #1d1d1b;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-3 {\n        fill: #1d1d1b;\n        font-family: MyriadPro-Regular, 'Myriad Pro';\n        font-size: 21.94px;\n      }\n    "
                        }
                    </style>
                </defs>
                <g id="Capa_1" data-name="Capa 1">
                    <path
                        className="cls-2"
                        d="m106.09,925.41c217.39,38.68,439.96,39.44,657.85,2.14"
                    />
                    <path
                        className="cls-2"
                        d="m105.71,94.04c217.89-37.29,440.46-36.53,657.85,2.14"
                    />
                    <line className="cls-2" x1={106.09} y1={94.01} x2={106.09} y2={925.41} />
                    <line className="cls-2" x1={763.56} y1={96.18} x2={763.56} y2={927.59} />
                    <line className="cls-2" x1={0.5} y1={1005.29} x2={0.5} />
                    <line className="cls-2" x1={882.87} y1={1005.29} x2={882.87} y2={5.29} />
                    <circle className="cls-2" cx={441.53} cy={47.76} r={7.89} />
                    <rect
                        className="cls-2"
                        x={300.91}
                        y={85.11}
                        width={279.5}
                        height={854.68}
                    />
                    <line className="cls-2" x1={367.85} y1={939.79} x2={367.82} y2={85.11} />
                    <line className="cls-2" x1={513.9} y1={939.79} x2={513.87} y2={85.11} />
                    <g>
                        <rect
                            className="cls-2"
                            x={368.25}
                            y={768.63}
                            width={145.65}
                            height={31.7}
                        />
                        <rect
                            className="cls-2"
                            x={473.87}
                            y={768.63}
                            width={40.03}
                            height={31.7}
                        />
                        <text className="cls-3" transform="translate(499.92 791.8) rotate(-90)">
                            <tspan x={0} y={0}>
                                {"3"}
                            </tspan>
                        </text>
                    </g>
                    <g>
                        <rect
                            className="cls-2"
                            x={367.94}
                            y={704.39}
                            width={145.65}
                            height={31.7}
                        />
                        <rect
                            className="cls-2"
                            x={472.95}
                            y={704.39}
                            width={40.03}
                            height={31.7}
                        />
                        <text
                            className="cls-3"
                            transform="translate(499.01 727.38) rotate(-90)"
                        >
                            <tspan x={0} y={0}>
                                {"4"}
                            </tspan>
                        </text>
                    </g>
                    <g>
                        <rect
                            className="cls-2"
                            x={367.84}
                            y={640.15}
                            width={145.65}
                            height={31.7}
                        />
                        <rect
                            className="cls-2"
                            x={473.46}
                            y={640.15}
                            width={40.03}
                            height={31.7}
                        />
                        <text
                            className="cls-3"
                            transform="translate(499.51 664.17) rotate(-90)"
                        >
                            <tspan x={0} y={0}>
                                {"5"}
                            </tspan>
                        </text>
                    </g>
                    <g>
                        <rect
                            className="cls-2"
                            x={367.84}
                            y={575.9}
                            width={145.65}
                            height={31.7}
                        />
                        <rect
                            className="cls-2"
                            x={473.15}
                            y={575.9}
                            width={40.03}
                            height={31.7}
                        />
                        <text
                            className="cls-3"
                            transform="translate(497.58 599.59) rotate(-90)"
                        >
                            <tspan x={0} y={0}>
                                {"6"}
                            </tspan>
                        </text>
                    </g>
                    <g>
                        <rect
                            className="cls-2"
                            x={367.84}
                            y={511.66}
                            width={145.65}
                            height={31.7}
                        />
                        <rect
                            className="cls-2"
                            x={472.54}
                            y={511.66}
                            width={40.03}
                            height={31.7}
                        />
                        <text
                            className="cls-3"
                            transform="translate(498.84 532.43) rotate(-90)"
                        >
                            <tspan x={0} y={0}>
                                {"7"}
                            </tspan>
                        </text>
                    </g>
                    <g>
                        <rect
                            className="cls-2"
                            x={368.55}
                            y={447.41}
                            width={145.65}
                            height={31.7}
                        />
                        <rect
                            className="cls-2"
                            x={473.87}
                            y={447.41}
                            width={40.03}
                            height={31.7}
                        />
                        <text className="cls-3" transform="translate(500.4 467.82) rotate(-90)">
                            <tspan x={0} y={0}>
                                {"8"}
                            </tspan>
                        </text>
                    </g>
                    <g>
                        <rect
                            className="cls-2"
                            x={367.84}
                            y={383.17}
                            width={145.65}
                            height={31.7}
                        />
                        <rect
                            className="cls-2"
                            x={473}
                            y={383.17}
                            width={40.03}
                            height={31.7}
                        />
                        <text
                            className="cls-3"
                            transform="translate(499.54 404.11) rotate(-90)"
                        >
                            <tspan x={0} y={0}>
                                {"9"}
                            </tspan>
                        </text>
                    </g>
                    <g>
                        <rect
                            className="cls-2"
                            x={368.55}
                            y={897.12}
                            width={145.65}
                            height={31.7}
                        />
                        <rect
                            className="cls-2"
                            x={473.7}
                            y={897.12}
                            width={40.03}
                            height={31.7}
                        />
                        <text className="cls-3" transform="translate(499.16 919) rotate(-90)">
                            <tspan x={0} y={0}>
                                {"1"}
                            </tspan>
                        </text>
                    </g>
                    <g>
                        <rect
                            className="cls-2"
                            x={368.33}
                            y={318.93}
                            width={145.65}
                            height={31.7}
                        />
                        <rect
                            className="cls-2"
                            x={474.09}
                            y={318.93}
                            width={40.03}
                            height={31.7}
                        />
                        <text
                            className="cls-3"
                            transform="translate(500.27 346.32) rotate(-90)"
                        >
                            <tspan x={0} y={0}>
                                {"10"}
                            </tspan>
                        </text>
                    </g>
                    <g>
                        <rect
                            className="cls-2"
                            x={367.84}
                            y={254.68}
                            width={145.65}
                            height={31.7}
                        />
                        <rect
                            className="cls-2"
                            x={472.69}
                            y={254.68}
                            width={40.03}
                            height={31.7}
                        />
                        <text
                            className="cls-3"
                            transform="translate(499.71 282.82) rotate(-90)"
                        >
                            <tspan x={0} y={0}>
                                {"11"}
                            </tspan>
                        </text>
                    </g>
                    <g>
                        <text
                            className="cls-3"
                            transform="translate(498.63 854.98) rotate(-90)"
                        >
                            <tspan x={0} y={0}>
                                {"2"}
                            </tspan>
                        </text>
                        <rect
                            className="cls-2"
                            x={368.33}
                            y={832.88}
                            width={145.65}
                            height={31.7}
                        />
                        <rect
                            className="cls-2"
                            x={473.95}
                            y={832.88}
                            width={40.03}
                            height={31.7}
                        />
                    </g>
                    <g>
                        <rect
                            className="cls-2"
                            x={368.71}
                            y={188.54}
                            width={145.65}
                            height={31.7}
                        />
                        <rect
                            className="cls-2"
                            x={473.87}
                            y={188.54}
                            width={40.03}
                            height={31.7}
                        />
                        <text
                            className="cls-3"
                            transform="translate(500.89 216.96) rotate(-90)"
                        >
                            <tspan x={0} y={0}>
                                {"12"}
                            </tspan>
                        </text>
                    </g>
                    <g>
                        <rect
                            className="cls-2"
                            x={368.25}
                            y={122.4}
                            width={145.65}
                            height={31.7}
                        />
                        <rect
                            className="cls-2"
                            x={473.87}
                            y={122.4}
                            width={40.03}
                            height={31.7}
                        />
                        <text
                            className="cls-3"
                            transform="translate(500.89 151.09) rotate(-90)"
                        >
                            <tspan x={0} y={0}>
                                {"13"}
                            </tspan>
                        </text>
                    </g>
                </g>
                <g id="AthMagnetsGroup" data-name="Capa 5">
                    <g className="AthMagnets" onClick={e => handleCircle(e)}>
                        <rect
                            className="cls-2"
                            x={514.2}
                            y={902.02}
                            width={36.96}
                            height={21.8}
                        />
                        <ellipse className="cls-2" cx={551.28} cy={912.92} rx={3.46} ry={10.9} />
                    </g>

                    <g className="AthMagnets" onClick={e => handleCircle(e)}>
                        <rect
                            className="cls-2"
                            x={514.2}
                            y={837.83}
                            width={36.96}
                            height={21.8}
                        />
                        <ellipse className="cls-2" cx={551.28} cy={848.73} rx={3.46} ry={10.9} />
                    </g>

                    <g className="AthMagnets" onClick={e => handleCircle(e)}>
                        <rect
                            className="cls-2"
                            x={514.2}
                            y={773.58}
                            width={36.96}
                            height={21.8}
                        />
                        <ellipse className="cls-2" cx={551.28} cy={784.48} rx={3.46} ry={10.9} />

                    </g>
                    <g className="AthMagnets" onClick={e => handleCircle(e)}>
                        <rect
                            className="cls-2"
                            x={513.98}
                            y={709.34}
                            width={36.96}
                            height={21.8}
                        />
                        <ellipse className="cls-2" cx={551.06} cy={720.24} rx={3.46} ry={10.9} />

                    </g>
                    <g className="AthMagnets" onClick={e => handleCircle(e)}>
                        <rect
                            className="cls-2"
                            x={513.98}
                            y={645.57}
                            width={36.96}
                            height={21.8}
                        />
                    <ellipse className="cls-2" cx={551.06} cy={656.47} rx={3.46} ry={10.9} />


                    </g>
                    <g className="AthMagnets" onClick={e => handleCircle(e)}>
                        <rect
                            className="cls-2"
                            x={513.89}
                            y={580.85}
                            width={36.96}
                            height={21.8}
                        />
                    <ellipse className="cls-2" cx={550.96} cy={591.75} rx={3.46} ry={10.9} />


                    </g>
                    <g className="AthMagnets" onClick={e => handleCircle(e)}>
                        <rect
                            className="cls-2"
                            x={514.2}
                            y={516.61}
                            width={36.96}
                            height={21.8}
                        />
                    <ellipse className="cls-2" cx={551.28} cy={527.51} rx={3.46} ry={10.9} />


                    </g>
                    <g className="AthMagnets" onClick={e => handleCircle(e)}>
                        <rect
                            className="cls-2"
                            x={514.2}
                            y={452.36}
                            width={36.96}
                            height={21.8}
                        />
                    <ellipse className="cls-2" cx={551.28} cy={463.26} rx={3.46} ry={10.9} />

                    </g>
                    <g className="AthMagnets" onClick={e => handleCircle(e)}>
                        <rect
                            className="cls-2"
                            x={513.89}
                            y={388.12}
                            width={36.96}
                            height={21.8}
                        />

                    <ellipse className="cls-2" cx={550.96} cy={399.02} rx={3.46} ry={10.9} />
                    </g>

                    <g className="AthMagnets" onClick={e => handleCircle(e)}>
                        <rect
                            className="cls-2"
                            x={514.2}
                            y={324.59}
                            width={36.96}
                            height={21.8}
                        />
                    <ellipse className="cls-2" cx={551.28} cy={335.49} rx={3.46} ry={10.9} />

                    </g>

                    <g className="AthMagnets" onClick={e => handleCircle(e)}>
                        <rect
                            className="cls-2"
                            x={514.36}
                            y={260.34}
                            width={36.96}
                            height={21.8}
                        />

                    <ellipse className="cls-2" cx={551.43} cy={271.24} rx={3.46} ry={10.9} />
                    </g>

                    <g className="AthMagnets" onClick={e => handleCircle(e)}>
                        <rect
                            className="cls-2"
                            x={514.36}
                            y={193.19}
                            width={36.96}
                            height={21.8}
                        />
                    <ellipse className="cls-2" cx={551.43} cy={204.09} rx={3.46} ry={10.9} />

                    </g>

                    <g className="AthMagnets" onClick={e => handleCircle(e)}>
                        <rect
                            className="cls-2"
                            x={513.98}
                            y={127.35}
                            width={36.96}
                            height={21.8}
                        />
                    <ellipse className="cls-2" cx={551.06} cy={138.25} rx={3.46} ry={10.9} />
                    </g>
                </g>
            </svg>
        </div>
    )
}